{
  "caption": "Ten phases by ten phases. Rows are the question's phase, columns the chosen option's phase.",
  "phases": {
    "pluto": "Spirit",
    "neptune": "Management",
    "uranus": "Leadership",
    "saturn": "Requirements",
    "sun": "Conceptualising",
    "moon": "Assessing",
    "mars": "Developing",
    "mercury": "Metaphor",
    "jupiter": "Operations",
    "venus": "Results"
  },
  "stats": {
    "total": "Σ",
    "totalLabel": "Total",
    "sd": "SD",
    "sdLabel": "Standard deviation",
    "grid": "Whole grid",
    "gridSummary": "n {{n}} · Σ {{total}} · SD {{sd}}"
  }
}
